import { getVisibilityColumns } from '@components/ColumnsVisibilityToggle/getVisibilityColumns';

import columns from './columns';

const documentsVisibilityColumns = getVisibilityColumns(columns([]));
const clientDocumentsVisibilityColumns = documentsVisibilityColumns.map(
  column => ({
    ...column,
    hide:
      column.key === 'clientName' || column.key === 'clientRut'
        ? true
        : column.hide,
  }),
);
const debtorDocumentsVisibilityColumns = documentsVisibilityColumns.map(
  column => ({
    ...column,
    hide:
      column.key === 'debtorName' || column.key === 'debtorRut'
        ? true
        : column.hide,
  }),
);

export { clientDocumentsVisibilityColumns, debtorDocumentsVisibilityColumns };
